import BaseDataObject from "../objects/base.nmcom_data.object";
import BaseAdapter from "../adapters/base.nmcom.adapter";
import {isObject, isArray, isFunction} from "../utils/checking.util";


export default class BaseModel extends BaseDataObject {
	static adapter = BaseAdapter;
	static endpoint; // The default endpoint to use if none is overriding specifically
	endpoint; // The instance of endpoint, can be overriden if necessary
	id;

	static transformResponseData(data) {
		if(!isObject(data)) {
			data = {};
		}

		return data;
	}

	static serializeRequestData(data) {
		if(!isObject(data)) {
			data = {};
		}

		return data;
	}

	constructor(data) {
		super(data);

		this.id = undefined;
		this.endpoint = this.endpoint || this.constructor.endpoint;

		data = this.fill(data);
	}

	fill(data) {
		for(let key in data) {
			let value = data[key];

			if(this[key] instanceof BaseDataObject) {
				this[key].fill(value);
			} else {
				this[key] = value;
			}
		}

		return this;
	}

	serialize(properties) {
		if(!isArray(properties)) {
			properties = [];

			for(let prop in this) {
				// Exclude specific keywords and anything that's a function from being serialized
				if(!isFunction(this[prop]) && ["endpoint"].indexOf(prop) === -1) {
					properties.push(prop);
				}
			}
		}

		const serializedObject = {};

		for(let index in properties) {
			let prop = properties[index];

			if(this[prop] instanceof BaseDataObject) {
				serializedObject[prop] = this[prop].serialize();
			} else {
				serializedObject[prop] = this[prop];
			}
		}

		return serializedObject;
	}

	promiseFetch(options = {}) {
		return this.constructor.adapter.promiseFetch(this, options);
	}

	promiseCreate(options = {}) {
		return this.constructor.adapter.promiseCreate(this, options);
	}

	promiseSave(options = {}) {
		return this.constructor.adapter.promiseSave(this, options);
	}

	promiseDestroy(options = {}) {
		return this.constructor.adapter.promiseDestroy(this, options);
	}
}
